import React from 'react';
import RoomReserve from './RoomReserve';
import PropertyList from './PropertyList';
import { useSelector } from 'react-redux';
import ProgressSteps from './ProgressSteps';

const SearchPage = () => {
  // Get dates directly from Redux
  const checkInDate = useSelector((state) => state.selectedDates.checkInDate);
  const checkOutDate = useSelector((state) => state.selectedDates.checkOutDate);

  const calculateCorrectDates = (checkin, checkout) => {
    if (!checkin) return {};

    let checkinDate = new Date(checkin);
    let checkoutDate = new Date(checkout);

    if (!checkout || checkoutDate <= checkinDate) {
      checkoutDate = new Date(checkinDate);
      checkoutDate.setDate(checkinDate.getDate() + 1);
    }

    return {
      checkin_date: checkinDate.toISOString().split('T')[0],
      checkout_date: checkoutDate.toISOString().split('T')[0],
    };
  };

  const correctedDates = calculateCorrectDates(checkInDate, checkOutDate);

  return (
    <div className="min-h-screen p-4 mt-16 relative">
      <ProgressSteps currentStep={1} />
      <RoomReserve />
      <PropertyList dates={correctedDates} />
    </div>
  );
};

export default SearchPage;

// import React, { useState } from "react";
// import RoomReserve from "./RoomReserve";
// import PropertyList from "./PropertyList";
// import { Link } from "react-router-dom";
// import { IoMdArrowRoundBack } from "react-icons/io";
// import { FaSearch, FaHotel, FaCheckCircle } from "react-icons/fa";

// const SearchPage = () => {
//   const [dates, setDates] = useState({
//     checkin_date: "",
//     checkout_date: "",
//   });
//   const [currentStep, setCurrentStep] = useState(1);

//   const steps = [
//     { id: 1, icon: FaSearch, title: "Reserve Stay" },
//     { id: 2, icon: FaHotel, title: "Enhance Stay" },
//     { id: 3, icon: FaCheckCircle, title: "Payment" },
//   ];

//   const calculateCorrectDates = (checkin, checkout) => {
//     if (!checkin) return {};

//     let checkinDate = new Date(checkin);
//     let checkoutDate = new Date(checkout);

//     if (!checkout || checkoutDate <= checkinDate) {
//       checkoutDate = new Date(checkinDate);
//       checkoutDate.setDate(checkinDate.getDate() + 1);
//     }

//     return {
//       checkin_date: checkinDate.toISOString().split("T")[0],
//       checkout_date: checkoutDate.toISOString().split("T")[0],
//     };
//   };

//   const correctedDates = calculateCorrectDates(
//     dates.checkin_date,
//     dates.checkout_date
//   );

//   const handleNext = () => {
//     if (currentStep < steps.length) {
//       setCurrentStep(currentStep + 1);
//     }
//   };

//   const handlePrev = () => {
//     if (currentStep > 1) {
//       setCurrentStep(currentStep - 1);
//     }
//   };

//   return (
//     <div className="min-h-screen p-4 mt-16  relative">

//       {/* Progress Steps */}
//       <div className=" mx-auto mb- p-4 bg-white rounded-lg shadow-sm">
//         <div className="flex justify-between relative">
//           {steps.map((step) => (
//             <div
//               key={step.id}
//               className="flex flex-col items-center z-10"
//               style={{ width: `${100/steps.length}%` }}
//             >
//               <div
//                 className={`w-10 h-10 rounded-full flex items-center justify-center border-2 ${
//                   currentStep >= step.id ? 'border-black bg-white' : 'border-gray-300 bg-gray-100'
//                 }`}
//               >
//                 <step.icon className={`text-sm ${
//                   currentStep >= step.id ? 'text-black' : 'text-gray-500'
//                 }`} />
//               </div>
//               <span className={`text-xs mt-1 text-center font-medium ${
//                 currentStep >= step.id ? 'text-black' : 'text-gray-500'
//               }`}>
//                 {step.title}
//               </span>
//             </div>
//           ))}
//           <div className="absolute top-5 left-10 right-10 h-1 bg-gray-200">
//             <div
//               className="h-1 bg-black transition-all duration-300"
//               style={{ width: `${((currentStep - 1) / (steps.length - 1)) * 100}%` }}
//             ></div>
//           </div>
//         </div>
//       </div>

//       {/* Main Content */}
//       <RoomReserve setDates={setDates} />
//       <PropertyList dates={correctedDates} />

//       {/* Navigation Buttons */}
//       <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 flex justify-between gap-4">
//         <button
//           onClick={handlePrev}
//           disabled={currentStep === 1}
//           className={`py-2 px-6 rounded-md font-medium transition-colors ${
//             currentStep === 1
//               ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
//               : 'bg-gray-100 text-gray-800 hover:bg-gray-200'
//           }`}
//         >
//           Previous
//         </button>
//         <button
//           onClick={handleNext}
//           disabled={currentStep === steps.length}
//           className={`py-2 px-6 rounded-md font-medium transition-colors ${
//             currentStep === steps.length
//               ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
//               : 'bg-black text-white hover:bg-gray-800'
//           }`}
//         >
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default SearchPage;
